declare namespace $ {

	export class $shm_hitalama_map_widget_float_component_view extends $shm_hitalama_map_widget_float_customdom {
		content( ): readonly(any)[]
		head( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=view.view.tree.d.ts.map